import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
const About = () => { 
  return (
    <>
      <div className="breadcrumb">
        <h2>Management</h2>
        <ul>
          <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
          <li>|</li> 
          <li>School</li>
          <li>|</li>
          <li>Management</li>
        </ul>
      </div>
      <div className="inner_page">
        <div className="container">
            <div className="row"> 
                <div className="col-md-12"> 
                    <h3 className="heading">Management</h3>
                    <p>St. francis School at Amritsar Locally administered by<span> The Franciscan sisters of St. Mary of the Angels</span> under the guidance and direction of <span> Fr. John Ediyakunnel</span> the Principal appointed by the Diocese of Jalandhar. The religious Sisters who are serving in the various Christian institutions in Punjab and elsewhere are people who voluntarily vowed to God to lead a Holy and dedicated life of selfless service to their fellow human being. In order to surrender themselves totally to the love of God and service of humanity they renounce family life and live in religious communities know as convents, a home of prayer and serenity. The school management is committed to the cause of education as the mission of Christ, the Divine Teacher</p>                   
                </div> 
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/patrons.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Dr. Franco Mulakkal</h3>
                        <p>Patron</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/Bishop.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3> Jose Sebestian T</h3>
                        <p>Bishop</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/chairman.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Rev. Fr. Jose Palakuzha</h3>
                        <p>Chairman, DBE</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/drtr.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Rev. Fr. Mathew Joseph Manalumparayil</h3>
                        <p>Director</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/mgmt-4.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Sr. Priya</h3>
                        <p>Principal</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/mgmt-5.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Sr. M Salome</h3>
                        <p>Incharge-Junior Section</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6">
                    <div className="management-blk">
                        <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/mgmt-6.png" alt="St Francis School, Amritsar" /> </LazyLoad>
                        <h3>Sr. Pritika</h3>
                        <p>Incharge-Primary Section</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default About
